import algoliasearch from 'algoliasearch';

const client = algoliasearch(
  process.env.REACT_APP_APPLICATION_ID,
  process.env.REACT_APP_API_KEY
);

export const index = client.initIndex(process.env.REACT_APP_INDEX_NAME);
